import React, { useState } from "react";
import Container from "./styled";
import { IoClose } from "react-icons/io5";

export default function ReferidosStepThree({ handleClose, nextStep }) {
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    let errors = {};

    if (!formValues.nombre) {
      errors.nombre = "El nombre es requerido.";
    }
    if (!formValues.telefono) {
      errors.telefono = "El teléfono es requerido.";
    }

    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      nextStep();
    }
  };

  return (
    <Container>
      <div className="closeButtonContainer">
        <a onClick={handleClose}>
          <IoClose />
        </a>
      </div>
      <h3>¡Aprovechá nuestro programa de referidos!</h3>
      <p>
        ¡Muchas gracias por tu aporte! Podés dejarnos los datos de tu referido
        acá.
      </p>
      <div className="inputContainer">
        <label>Nombre del referido</label>
        <input
          placeholder="Jane Doe"
          name="nombre"
          onChange={handleChange}
          value={formValues.nombre}
        ></input>
      </div>
      <div className="inputContainer">
        <label>Celular del referido</label>
        <input
          placeholder="1561528778"
          name="telefono"
          onChange={handleChange}
          value={formValues.telefono}
        ></input>
        <div id="errorsContainer">
          <p>{formErrors.nombre && <span>{formErrors.nombre}</span>}</p>
          <p>{formErrors.telefono && <span>{formErrors.telefono}</span>}</p>
        </div>
      </div>
      <button onClick={validateForm}>Enviar</button>
    </Container>
  );
}
